(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-product-boutique"] && !Shopify.designMode) return;
  try {
    
  function setupDbProductExperience() {
    document.querySelectorAll('.product--main:has(.db-pdp-overline)').forEach((root) => {
      const ensureVisibleMedia = () => {
        const gallery = root.querySelector('.product__media-container.above-mobile');
        const items = [...(gallery?.querySelectorAll('.product__media-item') || [])];
        if (items.length && items.every((item) => item.classList.contains('hidden'))) {
          items[0].classList.remove('hidden');
        }
      };
      ensureVisibleMedia();
      const disableStoreOnlyPurchasing = () => {
        if (!root.querySelector('.db-store-only-overline')) return;
        root.querySelectorAll('form.product-form.visually-hidden').forEach((form) => {
          form.inert = true;
          form.setAttribute('aria-hidden', 'true');
        });
        root.querySelectorAll('.product-form__cart-submit[data-add-to-cart]').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-hidden', 'true');
          button.tabIndex = -1;
        });
      };
      disableStoreOnlyPurchasing();
      const syncOptionLabels = () => {
        root.querySelectorAll('.product__option').forEach((group) => {
          const label = group.querySelector('.product__label-wrapper .product__label');
          const original = label?.firstChild?.textContent?.trim().toLowerCase() || '';
          const kind = group.dataset.dbOptionKind ||
            (/^(maat|size)\b/.test(original) ? 'size' : /^(kleur|color|colour)\b/.test(original) ? 'color' : '');
          if (!kind || !label) return;
          group.dataset.dbOptionKind = kind;
          const choices = [...group.querySelectorAll('[data-option-value]')].map((button) => button.dataset.optionValue);
          if (!choices.length) choices.push(...[...group.querySelectorAll('select option')].map((option) => option.value).filter(Boolean));
          if (kind === 'color') group.hidden = new Set(choices).size <= 1;
          if (label.firstChild?.nodeType === Node.TEXT_NODE) {
            label.firstChild.nodeValue = kind === 'size' ? 'Kies jouw maat' : 'Kies de gewenste kleur';
          }
          const current = label.querySelector('[data-selected-value-for-option]');
          if (current) current.hidden = true;
        });
      };
      syncOptionLabels();
      const stock = root.querySelector('[data-db-stock]');
      if (stock && !stock.dataset.ready) {
        stock.dataset.ready = 'true';
        const variants = JSON.parse(stock.querySelector('[data-db-stock-variants]').textContent).variants;
        const prompt = stock.querySelector('[data-db-stock-prompt]');
        const details = stock.querySelector('[data-db-stock-details]');
        const last = stock.querySelector('[data-db-stock-last]');
        const online = stock.querySelector('[data-db-stock-online]');
        const store = stock.querySelector('[data-db-stock-store]');
        const shipping = stock.querySelector('[data-db-stock-shipping]');
        const storeHint = stock.querySelector('[data-db-stock-store-hint]');
        const update = (chosen) => {
          prompt.hidden = chosen;
          details.hidden = !chosen;
          if (!chosen) return;
          const id = root.querySelector('[data-variant-select]')?.value || new URLSearchParams(window.location.search).get('variant') || root.dataset.currentProductId;
          const variant = variants[id];
          if (!variant) { details.hidden = true; return; }
          const count = Number(variant.quantity);
          const tracked = !!variant.tracked && Number.isFinite(count);
          const soldOut = !variant.available || (tracked && count <= 0 && variant.policy === 'deny');
          details.classList.toggle('is-sold-out', soldOut);
          last.hidden = soldOut || !(tracked && count === 1 && variant.policy === 'deny');
          shipping.hidden = soldOut;
          storeHint.hidden = soldOut;
          if (soldOut) {
            online.textContent = stock.dataset.dbHasSize === 'true' ? 'Deze maat is helaas uitverkocht' : 'Dit artikel is helaas uitverkocht';
            store.textContent = 'Ook in onze winkel in Sittard niet meer beschikbaar';
          } else if (tracked && count > 0 && count <= 3 && variant.policy === 'deny') {
            online.textContent = 'Online beperkt op voorraad';
          } else if (tracked && count <= 0 && variant.policy === 'continue') {
            online.textContent = 'Online op bestelling beschikbaar';
          } else {
            online.textContent = 'Online beschikbaar';
          }
          if (!soldOut) store.textContent = tracked && count <= 0 ? 'Vraag ons naar beschikbaarheid in Sittard' : 'Ook beschikbaar in onze winkel in Sittard';
        };
        update(root.dataset.productHasOnlyDefaultVariant === 'true' || new URLSearchParams(window.location.search).has('variant'));
        const syncSelection = () => {
          requestAnimationFrame(() => update(true));
          setTimeout(() => update(true), 120);
        };
        root.addEventListener('click', (event) => {
          if (event.target.closest('.product__option button[data-option-value]')) syncSelection();
        });
        root.addEventListener('change', (event) => {
          if (event.target.matches('.product__option select[name^="options["], [data-variant-select]')) syncSelection();
        });
      }
      const storeStock = root.querySelector('[data-db-store-stock]');
      if (storeStock && !storeStock.dataset.ready) {
        storeStock.dataset.ready = 'true';
        const data = JSON.parse(storeStock.querySelector('[data-db-store-variants]').textContent);
        const status = storeStock.querySelector('[data-db-store-status]');
        const sizes = storeStock.querySelector('[data-db-store-sizes]');
        const updateStoreStock = () => {
          const id = root.querySelector('[data-variant-select]')?.value || new URLSearchParams(window.location.search).get('variant') || root.dataset.currentProductId;
          const variant = data.variants.find((item) => item.id === String(id));
          status.classList.remove('is-unavailable', 'is-unknown');
          sizes.hidden = true;
          if (!variant) {
            status.textContent = 'Kies jouw maat om de winkelvoorraad te bekijken.';
            return;
          }
          const size = data.sizeIndex >= 0 ? variant.options[data.sizeIndex] : null;
          const name = size ? `Maat ${size}` : 'Dit artikel';
          const count = Number(variant.quantity);
          const tracked = !!variant.tracked && Number.isFinite(count);
          if (tracked && count > 0) {
            status.textContent = `${name} is op voorraad in onze winkel in Sittard.`;
          } else if (tracked || !variant.available) {
            status.textContent = `${name} is helaas niet op voorraad in onze winkel in Sittard.`;
            status.classList.add('is-unavailable');
          } else {
            status.textContent = `Vraag ons naar de actuele beschikbaarheid van ${size ? `maat ${size}` : 'dit artikel'} in Sittard.`;
            status.classList.add('is-unknown');
          }
          if (data.sizeIndex < 0) return;
          const sameColor = data.variants.filter((item) => item.options.every((value, index) => index === data.sizeIndex || value === variant.options[index]));
          const availableSizes = [...new Set(sameColor.filter((item) => !!item.tracked && Number(item.quantity) > 0).map((item) => item.options[data.sizeIndex]))];
          if (availableSizes.length) {
            sizes.textContent = `Maten op voorraad in Sittard: ${availableSizes.join(' · ')}`;
            sizes.hidden = false;
          }
          root.querySelectorAll('.product__option[data-db-option-kind="size"] button[data-option-value]').forEach((button) => {
            const candidates = sameColor.filter((item) => item.options[data.sizeIndex] === button.dataset.optionValue);
            const available = candidates.some((item) => !!item.tracked && Number(item.quantity) > 0);
            const unknown = candidates.some((item) => !item.tracked && item.available);
            const soldOut = candidates.length > 0 && !available && !unknown;
            button.classList.toggle('db-store-soldout', soldOut);
            button.setAttribute('aria-label', `Maat ${button.dataset.optionValue}, ${available ? 'op voorraad in Sittard' : unknown ? 'voorraad navragen' : 'niet op voorraad in Sittard'}`);
          });
        };
        updateStoreStock();
        const syncStoreSelection = () => {
          requestAnimationFrame(updateStoreStock);
          setTimeout(updateStoreStock, 120);
        };
        root.addEventListener('click', (event) => {
          if (event.target.closest('.product__option button[data-option-value]')) syncStoreSelection();
        });
        root.addEventListener('change', (event) => {
          if (event.target.matches('.product__option select[name^="options["], [data-variant-select]')) syncStoreSelection();
        });
        window.addEventListener('popstate', syncStoreSelection);
      }
      if (!root.dataset.dbTryOnObserver) {
        root.dataset.dbTryOnObserver = 'true';
        let pending = false;
        const moveLabels = () => {
          const left = root.querySelector('.product__primary-left');
          if (!left) return;
          const labels = [...root.querySelectorAll('.product__primary-right .product-block-custom-liquid')]
            .filter((block) => block.querySelector('.product-department'));
          if (!labels.length) return;
          let holder = left.querySelector('.db-pdp-labels');
          if (!holder) {
            holder = document.createElement('div');
            holder.className = 'db-pdp-labels';
            left.prepend(holder);
          }
          labels.forEach((block) => holder.append(block));
        };
        const moveTryOn = () => {
          const widget = root.querySelector('.product-form antla-block');
          const left = root.querySelector('.product__primary-left');
          if (!widget || !left) return;
          let holder = left.querySelector('.db-virtual-try-on');
          if (!holder) {
            holder = document.createElement('div');
            holder.className = 'db-virtual-try-on';
            const following = left.querySelector('.left-side-blocks');
            if (following) following.before(holder);
            else left.append(holder);
          }
          holder.append(widget);
        };
        moveLabels();
        moveTryOn();
        new MutationObserver(() => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => { pending = false; moveLabels(); moveTryOn(); ensureVisibleMedia(); syncOptionLabels(); disableStoreOnlyPurchasing(); });
        }).observe(root, { childList: true, subtree: true });
      }
    });
  }
  setupDbProductExperience();
  document.addEventListener('shopify:section:load', setupDbProductExperience);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const syncCartSummary = () => {
      document.querySelectorAll('.cart-section').forEach((section) => {
        const subtotal = section.querySelector('.cart__footer-subtotal span');
        const total = section.querySelector('[data-db-cart-total]');
        const shipping = section.querySelector('.db-cart-shipping');
        if (!subtotal || !total || !shipping) return;
        const amount = subtotal.textContent.trim();
        if (total.textContent.trim() !== amount) total.textContent = amount;
        if (shipping.dataset.dbCartCurrency !== 'EUR') return;
        const match = amount.match(/[\d.,]+/);
        if (!match) return;
        const cents = Math.round(Number(match[0].replace(/\./g, '').replace(',', '.')) * 100);
        const label = cents >= Number(shipping.dataset.dbCartThreshold) ? 'Gratis*' : 'Berekend bij afrekenen';
        const value = shipping.querySelector('strong');
        if (value && value.textContent !== label) value.textContent = label;
      });
    };
    syncCartSummary();
    new MutationObserver(syncCartSummary).observe(document.body, { childList: true, characterData: true, subtree: true });
    document.addEventListener('shopify:section:load', syncCartSummary);
  })();

  } catch(e) { console.error(e); }
})();
})();
